import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "m4.286 4.75 6.653 6.657v7.843l2.122-.537v-7.306l6.653-6.657z"
}), 'Filter');